export const getValue = ({
  condition,
  value,
  defaultValue,
}: {
  condition?: boolean;
  value: string;
  defaultValue: string;
}) => (condition ? value : defaultValue);
